const productData = [
  {
    id: 1,
    name: "Alfa Romeo Owner's Bible",
    category: "Automotive Books",
    price: "62.50",
    country: "Australia",
    reviews: "89",
    rating: "4.7",
    images: ["/img/101.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-45-2",
    pages: 384,
    description: [
      "The definitive guide to owning, maintaining, and enjoying your Alfa Romeo vehicle.",
      "Covers all major Alfa Romeo models from the classic Giulia to modern Giulietta and Stelvio.",
      "Written by automotive experts with decades of Alfa Romeo experience and passion.",
      "Includes detailed maintenance schedules, troubleshooting guides, and performance modifications.",
      "Features hundreds of color photographs and technical illustrations throughout.",
      "Essential buying advice for both new and used Alfa Romeo vehicles.",
      "Comprehensive coverage of common problems and their solutions.",
      "Tips for preserving and enhancing your Alfa Romeo's value and performance.",
      "Perfect for both enthusiasts and professional mechanics working on Alfa Romeo vehicles.",
    ],
    Features: [
      "Comprehensive Alfa Romeo model coverage",
      "Expert maintenance and repair guidance",
      "Detailed troubleshooting procedures",
      "Performance modification advice",
      "High-quality color photography",
      "Technical illustrations and diagrams",
      "Buying and selling tips",
      "Common problem solutions",
      "Professional mechanic insights",
      "Enthusiast-focused content",
      "Value preservation strategies",
      "384 pages of detailed information",
    ],
  },
  {
    id: 2,
    name: "Audi 100, 200: 1989-1991 Repair Manual",
    category: "Repair Manuals",
    price: "75.00",
    country: "Australia",
    reviews: "156",
    rating: "4.9",
    images: ["/img/102.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-12-4",
    pages: 512,
    description: [
      "Complete repair and maintenance manual for Audi 100 and 200 models from 1989 to 1991.",
      "Covers all engine variants including 2.0L, 2.2L, 2.3L petrol and 2.5L diesel engines.",
      "Step-by-step procedures for engine overhaul, transmission service, and electrical systems.",
      "Detailed wiring diagrams and component location guides for easy troubleshooting.",
      "Professional-quality photographs and illustrations accompany every procedure.",
      "Includes torque specifications, fluid capacities, and maintenance schedules.",
      "Covers both manual and automatic transmission variants comprehensively.",
      "Essential reference for mechanics, technicians, and serious DIY enthusiasts.",
      "Written by certified automotive technicians with extensive Audi experience.",
    ],
    Features: [
      "Complete 1989-1991 model coverage",
      "All engine variant procedures",
      "Step-by-step repair instructions",
      "Professional quality illustrations",
      "Detailed wiring diagrams",
      "Torque specifications included",
      "Maintenance schedule guidance",
      "Transmission service procedures",
      "Electrical system troubleshooting",
      "Component location guides",
      "Expert technical writing",
      "512 pages of detailed content",
    ],
  },
  {
    id: 3,
    name: "Audi 5000S, 5000CS: 1984-1988 Repair Manual",
    category: "Repair Manuals",
    price: "68.50",
    country: "Australia",
    reviews: "142",
    rating: "4.8",
    images: ["/img/103.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-08-7",
    pages: 468,
    description: [
      "Comprehensive repair manual for Audi 5000S and 5000CS models manufactured between 1984 and 1988.",
      "Covers all engine options including 2.1L 5-cylinder, 2.2L turbo, and diesel variants.",
      "Detailed procedures for engine rebuilding, fuel injection system service, and turbocharger maintenance.",
      "Complete electrical system coverage with detailed wiring diagrams and component testing procedures.",
      "Suspension, steering, and brake system repair procedures with torque specifications.",
      "Transmission and drivetrain service including manual and automatic variants.",
      "Body repair techniques and interior component replacement procedures.",
      "Troubleshooting charts for quick diagnosis of common problems.",
      "Professional-grade manual used by Audi dealerships and independent repair shops worldwide.",
    ],
    Features: [
      "1984-1988 model year coverage",
      "All engine variant procedures",
      "Turbocharger service guidance",
      "Complete electrical diagrams",
      "Fuel injection system details",
      "Suspension and brake procedures",
      "Transmission service steps",
      "Body repair techniques",
      "Troubleshooting charts included",
      "Professional dealership quality",
      "Independent shop approved",
      "468 pages of technical content",
    ],
  },
  {
    id: 4,
    name: "Audi A4 (B5) Service Manual: 1996, 1997, 1998, 1999, 2000, 2001",
    category: "Service Manuals",
    price: "89.95",
    country: "Australia",
    reviews: "203",
    rating: "4.9",
    images: ["/img/104.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-23-0",
    pages: 672,
    description: [
      "Complete service manual for Audi A4 (B5) models covering six model years from 1996 to 2001.",
      "Covers all engine variants including 1.6L, 1.8L, 1.8T turbo, 2.4L, 2.8L petrol and 1.9L TDI diesel engines.",
      "Detailed step-by-step procedures for engine overhaul, timing belt replacement, and turbocharger service.",
      "Comprehensive coverage of Quattro all-wheel-drive system maintenance and repair procedures.",
      "Complete electrical system documentation with detailed wiring diagrams and component locations.",
      "Transmission service procedures for both manual and automatic Tiptronic transmissions.",
      "Suspension, steering, and brake system repair with alignment specifications and procedures.",
      "Air conditioning, heating, and climate control system service and troubleshooting.",
      "Professional-quality manual trusted by Audi technicians and enthusiasts worldwide.",
    ],
    Features: [
      "Six model years coverage (1996-2001)",
      "All engine variants included",
      "Turbocharger service procedures",
      "Quattro AWD system coverage",
      "Complete electrical diagrams",
      "Tiptronic transmission service",
      "Suspension alignment specs",
      "Climate control procedures",
      "Professional technician quality",
      "Enthusiast-friendly format",
      "Detailed troubleshooting guides",
      "672 pages of comprehensive content",
    ],
  },
  {
    id: 5,
    name: "Audi A6 Electrical Wiring Manual",
    category: "Wiring Manuals",
    price: "54.95",
    country: "Australia",
    reviews: "98",
    rating: "4.6",
    images: ["/img/105.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-34-6",
    pages: 296,
    description: [
      "Comprehensive electrical wiring manual for Audi A6 models covering multiple generations.",
      "Detailed wiring diagrams for all electrical systems including engine management, lighting, and comfort systems.",
      "Component location guides with detailed photographs showing exact placement of electrical components.",
      "Connector pinout diagrams and wire color coding for accurate electrical troubleshooting.",
      "Fuse and relay location charts with amperage ratings and circuit protection information.",
      "Ground point locations and electrical system grounding diagrams for proper repairs.",
      "Diagnostic trouble code explanations and electrical system testing procedures.",
      "Essential reference for automotive electricians and technicians working on Audi A6 vehicles.",
      "Professional-quality diagrams used by Audi dealerships for electrical system diagnosis.",
    ],
    Features: [
      "Multiple A6 generation coverage",
      "Complete wiring diagrams",
      "Component location photos",
      "Connector pinout details",
      "Wire color coding system",
      "Fuse and relay charts",
      "Ground point locations",
      "Diagnostic code explanations",
      "Professional electrician quality",
      "Dealership-grade diagrams",
      "Troubleshooting procedures",
      "296 pages of electrical data",
    ],
  },
  {
    id: 6,
    name: "A Masterclass in needle felting endangered species",
    category: "Craft Books",
    price: "39.95",
    country: "Australia",
    reviews: "87",
    rating: "4.8",
    images: ["/img/106.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-67-4",
    pages: 224,
    description: [
      "Comprehensive guide to needle felting techniques focused on creating realistic endangered species sculptures.",
      "Step-by-step instructions for creating detailed wool sculptures of tigers, pandas, elephants, and other endangered animals.",
      "Expert techniques for achieving realistic textures, colors, and anatomical details in needle felted animals.",
      "Includes patterns and templates for 12 different endangered species projects.",
      "Detailed photography showing each stage of the needle felting process from start to finish.",
      "Tips for selecting the right wool types and colors for authentic-looking animal sculptures.",
      "Advanced techniques for creating facial features, fur textures, and realistic proportions.",
      "Conservation awareness information about each featured endangered species.",
      "Perfect for intermediate to advanced needle felting enthusiasts and wildlife art lovers.",
    ],
    Features: [
      "12 endangered species projects",
      "Step-by-step photo instructions",
      "Realistic texture techniques",
      "Anatomical detail guidance",
      "Wool selection advice",
      "Pattern templates included",
      "Advanced felting methods",
      "Conservation awareness content",
      "Wildlife art focus",
      "Expert crafting tips",
      "Intermediate to advanced level",
      "224 pages of detailed instruction",
    ],
  },
  {
    id: 7,
    name: "A PUPPY CALLED WOLFIE",
    category: "Children's Books",
    price: "24.95",
    country: "Australia",
    reviews: "156",
    rating: "4.9",
    images: ["/img/107.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-78-0",
    pages: 48,
    description: [
      "Heartwarming children's story about a young puppy named Wolfie and his adventures in finding a loving home.",
      "Beautifully illustrated tale that teaches children about friendship, loyalty, and the importance of family.",
      "Features stunning watercolor illustrations that bring Wolfie's world to life on every page.",
      "Age-appropriate story perfect for bedtime reading or independent reading for early readers.",
      "Includes valuable lessons about pet responsibility and the bond between children and animals.",
      "Written by award-winning children's author with decades of experience in educational storytelling.",
      "Large format book with easy-to-read text suitable for children aged 4-8 years.",
      "Promotes empathy and understanding of animal welfare through engaging storytelling.",
      "Perfect gift for young animal lovers and families considering pet adoption.",
    ],
    Features: [
      "Heartwarming puppy story",
      "Beautiful watercolor illustrations",
      "Age-appropriate for 4-8 years",
      "Educational pet responsibility themes",
      "Award-winning author",
      "Large format easy reading",
      "Bedtime story suitable",
      "Animal welfare awareness",
      "Family-friendly content",
      "Gift-worthy presentation",
      "Empathy-building narrative",
      "48 pages of illustrated story",
    ],
  },
  {
    id: 8,
    name: "Among The Wolves",
    category: "Wildlife Books",
    price: "45.95",
    country: "Australia",
    reviews: "134",
    rating: "4.7",
    images: ["/img/108.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-89-6",
    pages: 312,
    description: [
      "Fascinating exploration of wolf behavior and pack dynamics in their natural wilderness habitats.",
      "Based on decades of field research and observation by leading wildlife biologists and conservationists.",
      "Stunning wildlife photography capturing wolves in their natural environment across different seasons.",
      "Detailed analysis of wolf communication, hunting strategies, and social hierarchy within packs.",
      "Conservation success stories and ongoing efforts to protect wolf populations worldwide.",
      "Insights into the complex relationship between wolves and human communities throughout history.",
      "Scientific approach to understanding wolf ecology and their crucial role in ecosystem balance.",
      "Includes maps showing current wolf territories and population distribution globally.",
      "Essential reading for wildlife enthusiasts, conservationists, and nature lovers.",
    ],
    Features: [
      "Decades of field research",
      "Stunning wildlife photography",
      "Pack behavior analysis",
      "Communication studies",
      "Hunting strategy insights",
      "Conservation success stories",
      "Human-wolf relationship history",
      "Scientific ecological approach",
      "Global population mapping",
      "Wildlife enthusiast focus",
      "Conservation awareness",
      "312 pages of wildlife content",
    ],
  },
  {
    id: 9,
    name: "Animal Grief",
    category: "Psychology Books",
    price: "32.95",
    country: "Australia",
    reviews: "92",
    rating: "4.6",
    images: ["/img/109.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-91-9",
    pages: 256,
    description: [
      "Compassionate exploration of how animals experience and process grief and loss.",
      "Based on extensive research into animal behavior and emotional intelligence studies.",
      "Real-life stories of animals mourning the loss of companions, offspring, and human caregivers.",
      "Scientific evidence supporting the existence of complex emotions in various animal species.",
      "Insights into how different species express grief through behavior and social interactions.",
      "Guidance for pet owners dealing with grieving animals after the loss of a companion.",
      "Examination of mourning rituals observed in wild animal populations.",
      "Written by animal behaviorists and veterinary psychologists with decades of experience.",
      "Essential reading for animal lovers, veterinarians, and anyone interested in animal psychology.",
    ],
    Features: [
      "Animal behavior research",
      "Emotional intelligence studies",
      "Real-life grief stories",
      "Scientific evidence based",
      "Species-specific grief expressions",
      "Pet owner guidance",
      "Wild animal observations",
      "Expert behaviorist insights",
      "Veterinary psychology focus",
      "Animal lover essential",
      "Compassionate approach",
      "256 pages of research",
    ],
  },
  {
    id: 10,
    name: "BONDS – Capturing the Special Relationship",
    category: "Photography Books",
    price: "49.95",
    country: "Australia",
    reviews: "167",
    rating: "4.8",
    images: ["/img/1010.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-02-5",
    pages: 192,
    description: [
      "Stunning photographic collection celebrating the unique bonds between humans and their animal companions.",
      "Features heartwarming portraits of people with their beloved pets, farm animals, and wildlife.",
      "Professional photography capturing intimate moments that showcase the depth of human-animal relationships.",
      "Stories behind each photograph revealing the special connections between subjects and their animals.",
      "Includes diverse relationships from therapy animals to working dogs, rescue pets to wildlife conservationists.",
      "High-quality printing on premium paper stock to showcase the beauty of each photograph.",
      "Inspirational text accompanying images that celebrates the healing power of animal companionship.",
      "Perfect coffee table book for animal lovers and photography enthusiasts alike.",
      "Proceeds support animal welfare organizations and rescue groups worldwide.",
    ],
    Features: [
      "Professional photography collection",
      "Human-animal bond focus",
      "Heartwarming portraits",
      "Behind-the-scenes stories",
      "Diverse relationship types",
      "Premium paper quality",
      "Inspirational accompanying text",
      "Coffee table book format",
      "Animal welfare support",
      "Photography enthusiast appeal",
      "Healing power celebration",
      "192 pages of stunning imagery",
    ],
  },
  {
    id: 11,
    name: "Camper Vans, Ep-Pats & Spanish Hounds",
    category: "Travel Books",
    price: "36.95",
    country: "Australia",
    reviews: "145",
    rating: "4.7",
    images: ["/img/1011.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-13-1",
    pages: 288,
    description: [
      "Adventurous travel memoir following a couple's journey across Spain with their rescued Spanish hounds.",
      "Humorous and heartwarming tales of life on the road in a converted camper van with canine companions.",
      "Detailed guide to pet-friendly travel destinations and accommodations throughout Spain.",
      "Cultural insights into Spanish village life and the country's deep connection with hunting dogs.",
      "Practical advice for traveling with pets including border crossings, veterinary care, and safety tips.",
      "Beautiful photography of Spanish landscapes, architecture, and the authors' beloved hounds.",
      "Stories of rescue and rehabilitation of abandoned Spanish hunting dogs (galgos and podencos).",
      "Tips for converting and living in a camper van with pets for extended periods.",
      "Perfect for travel enthusiasts, dog lovers, and anyone dreaming of life on the road.",
    ],
    Features: [
      "Spanish travel memoir",
      "Pet-friendly travel guide",
      "Camper van lifestyle",
      "Spanish hound rescue stories",
      "Cultural village insights",
      "Practical pet travel advice",
      "Beautiful Spanish photography",
      "Van conversion tips",
      "Humorous travel tales",
      "Dog lover appeal",
      "Road trip inspiration",
      "288 pages of adventure",
    ],
  },
  {
    id: 12,
    name: "CANINE AGGRESSION",
    category: "Dog Training Books",
    price: "58.95",
    country: "Australia",
    reviews: "189",
    rating: "4.9",
    images: ["/img/1012.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-24-7",
    pages: 384,
    description: [
      "Comprehensive guide to understanding, preventing, and managing aggressive behavior in dogs.",
      "Written by certified animal behaviorists and veterinary specialists with decades of experience.",
      "Evidence-based training methods and behavior modification techniques for aggressive dogs.",
      "Detailed analysis of different types of aggression including fear-based, territorial, and resource guarding.",
      "Step-by-step protocols for safely working with aggressive dogs and preventing bite incidents.",
      "Case studies from real rehabilitation programs showing successful behavior modification outcomes.",
      "Guidance for dog owners, trainers, and veterinary professionals dealing with aggressive behavior.",
      "Safety protocols and management strategies for protecting both dogs and humans.",
      "Essential resource for anyone working with or owning dogs with behavioral challenges.",
    ],
    Features: [
      "Certified behaviorist expertise",
      "Evidence-based training methods",
      "Aggression type analysis",
      "Step-by-step protocols",
      "Safety incident prevention",
      "Real case study examples",
      "Professional guidance",
      "Management strategies",
      "Behavioral challenge focus",
      "Veterinary professional resource",
      "Dog owner essential",
      "384 pages of expert content",
    ],
  },
  {
    id: 13,
    name: "Cat Speak",
    category: "Pet Care Books",
    price: "29.95",
    country: "Australia",
    reviews: "123",
    rating: "4.5",
    images: ["/img/1013.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-35-3",
    pages: 208,
    description: [
      "Comprehensive guide to understanding feline communication and behavior patterns.",
      "Decode your cat's body language, vocalizations, and behavioral signals with expert insights.",
      "Written by feline behaviorists and veterinarians specializing in cat psychology.",
      "Learn to interpret different types of meows, purrs, and other vocal communications.",
      "Understanding territorial marking, scratching behavior, and social hierarchy in multi-cat homes.",
      "Practical advice for improving human-cat relationships through better communication.",
      "Troubleshooting common behavioral issues using positive reinforcement techniques.",
      "Illustrated guide showing different cat postures and their meanings.",
      "Essential reading for cat owners wanting to deepen their bond with their feline companions.",
    ],
    Features: [
      "Feline communication guide",
      "Body language interpretation",
      "Behaviorist expertise",
      "Vocalization decoding",
      "Multi-cat household advice",
      "Relationship improvement tips",
      "Positive reinforcement methods",
      "Illustrated posture guide",
      "Cat owner essential",
      "Behavioral issue solutions",
      "Expert veterinary insights",
      "208 pages of feline wisdom",
    ],
  },
  {
    id: 14,
    name: "Charlie: The dog who came in from the wild",
    category: "Animal Stories",
    price: "34.95",
    country: "Australia",
    reviews: "178",
    rating: "4.8",
    images: ["/img/1014.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-46-9",
    pages: 272,
    description: [
      "Heartwarming true story of a wild dog's transformation into a beloved family companion.",
      "Chronicles Charlie's journey from feral survival to learning trust and love with his adoptive family.",
      "Insights into the rehabilitation process for wild and feral dogs entering domestic life.",
      "Expert commentary on canine psychology and the adaptability of dogs to human companionship.",
      "Touching narrative that highlights the patience and dedication required for successful dog rescue.",
      "Educational content about feral dog behavior and the challenges they face in the wild.",
      "Inspiring story of second chances and the transformative power of love and patience.",
      "Beautiful photography documenting Charlie's remarkable transformation over time.",
      "Perfect for animal lovers, rescue advocates, and anyone interested in heartwarming true stories.",
    ],
    Features: [
      "True rescue story",
      "Feral to family transformation",
      "Rehabilitation insights",
      "Canine psychology expertise",
      "Patience and dedication themes",
      "Feral behavior education",
      "Second chance inspiration",
      "Transformation photography",
      "Animal lover appeal",
      "Rescue advocacy support",
      "Heartwarming narrative",
      "272 pages of inspiring content",
    ],
  },
  {
    id: 15,
    name: "Clever Dog – Life Lessons from the World's Most Successful Animal",
    category: "Self-Help Books",
    price: "42.95",
    country: "Australia",
    reviews: "234",
    rating: "4.9",
    images: ["/img/1015.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-57-5",
    pages: 320,
    description: [
      "Inspiring self-help book drawing life lessons from the remarkable adaptability and success of dogs.",
      "Explores how canine traits like loyalty, resilience, and living in the moment can improve human lives.",
      "Written by behavioral psychologists and dog experts who study human-canine relationships.",
      "Practical strategies for applying dog-like qualities to overcome life's challenges and find happiness.",
      "Real-life examples of how dogs have taught their owners valuable lessons about perseverance and joy.",
      "Scientific research on the psychological benefits of adopting canine-inspired mindsets.",
      "Chapters on loyalty, forgiveness, unconditional love, and finding joy in simple pleasures.",
      "Motivational stories of dogs overcoming adversity and their inspiring human companions.",
      "Perfect for dog lovers seeking personal growth and anyone looking for fresh perspectives on success.",
    ],
    Features: [
      "Canine-inspired life lessons",
      "Behavioral psychology insights",
      "Practical life strategies",
      "Real-life success examples",
      "Scientific research backing",
      "Loyalty and resilience focus",
      "Motivational adversity stories",
      "Personal growth guidance",
      "Dog lover appeal",
      "Fresh success perspectives",
      "Expert author collaboration",
      "320 pages of inspiration",
    ],
  },
  {
    id: 16,
    name: "Dairy Cows & Duck Races – the life & times of a young farmer",
    category: "Farm Life Books",
    price: "38.95",
    country: "Australia",
    reviews: "167",
    rating: "4.7",
    images: ["/img/1016.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-68-1",
    pages: 296,
    description: [
      "Charming memoir of a young person's journey into farming life with dairy cows and quirky farm traditions.",
      "Humorous and heartwarming stories of learning to care for livestock and navigate rural community life.",
      "Insights into sustainable farming practices and the daily rhythms of agricultural life.",
      "Tales of unusual farm events including the famous local duck races and seasonal celebrations.",
      "Educational content about dairy farming, animal husbandry, and rural Australian culture.",
      "Personal growth story showing how farm life teaches responsibility, patience, and connection to nature.",
      "Beautiful descriptions of countryside landscapes and the changing seasons on the farm.",
      "Practical wisdom about animal care, farm management, and building relationships with livestock.",
      "Perfect for anyone interested in farming, rural life, or heartwarming coming-of-age stories.",
    ],
    Features: [
      "Young farmer memoir",
      "Dairy farming insights",
      "Rural community stories",
      "Sustainable farming practices",
      "Duck race traditions",
      "Animal husbandry education",
      "Personal growth narrative",
      "Countryside descriptions",
      "Farm management wisdom",
      "Coming-of-age themes",
      "Rural Australian culture",
      "296 pages of farm life",
    ],
  },
  {
    id: 17,
    name: "Dieting With My Dog",
    category: "Health & Fitness Books",
    price: "31.95",
    country: "Australia",
    reviews: "189",
    rating: "4.6",
    images: ["/img/1017.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-79-7",
    pages: 224,
    description: [
      "Motivational weight loss journey shared between a dog owner and their overweight canine companion.",
      "Practical guide combining human and pet fitness routines for mutual health benefits.",
      "Expert advice from veterinarians and fitness trainers on safe exercise programs for both species.",
      "Nutritional guidance for creating healthy meal plans that work for both humans and dogs.",
      "Inspiring success stories of people and pets who achieved their fitness goals together.",
      "Fun exercise activities and games that keep both owner and dog motivated and engaged.",
      "Tips for overcoming common obstacles in maintaining consistent exercise routines.",
      "Scientific research on the health benefits of exercising with pets for accountability and motivation.",
      "Perfect for pet owners looking to improve their health while bonding with their furry companions.",
    ],
    Features: [
      "Dual species fitness approach",
      "Veterinary expert guidance",
      "Nutritional meal planning",
      "Motivational success stories",
      "Fun exercise activities",
      "Obstacle overcoming strategies",
      "Scientific research backing",
      "Pet-owner bonding focus",
      "Health improvement guidance",
      "Accountability partnership",
      "Practical fitness routines",
      "224 pages of health wisdom",
    ],
  },
  {
    id: 18,
    name: "Dinner With Rover",
    category: "Pet Care Books",
    price: "26.95",
    country: "Australia",
    reviews: "156",
    rating: "4.7",
    images: ["/img/1018.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-80-3",
    pages: 192,
    description: [
      "Comprehensive guide to proper nutrition and feeding practices for dogs of all ages and sizes.",
      "Expert advice from veterinary nutritionists on creating balanced, healthy meals for your canine companion.",
      "Recipes for homemade dog treats and meals using safe, nutritious ingredients.",
      "Guidelines for understanding dog food labels and choosing the best commercial options.",
      "Special dietary considerations for puppies, senior dogs, and dogs with health conditions.",
      "Tips for establishing healthy eating routines and preventing food-related behavioral issues.",
      "Information about toxic foods to avoid and emergency procedures for accidental ingestion.",
      "Portion control guidance and weight management strategies for overweight pets.",
      "Essential reading for dog owners who want to provide the best nutrition for their beloved pets.",
    ],
    Features: [
      "Veterinary nutritionist expertise",
      "Homemade recipe collection",
      "Commercial food guidance",
      "Age-specific dietary advice",
      "Health condition considerations",
      "Behavioral eating solutions",
      "Toxic food awareness",
      "Weight management strategies",
      "Emergency procedure guidance",
      "Portion control education",
      "Dog owner essential",
      "192 pages of nutrition wisdom",
    ],
  },
  {
    id: 19,
    name: "Dog Cookies",
    category: "Pet Recipe Books",
    price: "22.95",
    country: "Australia",
    reviews: "234",
    rating: "4.8",
    images: ["/img/1019.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-81-0",
    pages: 160,
    description: [
      "Delightful collection of healthy, homemade treat recipes that dogs absolutely love.",
      "Over 50 easy-to-follow recipes using simple, dog-safe ingredients found in most kitchens.",
      "Nutritional information and health benefits for each recipe, approved by veterinary nutritionists.",
      "Special occasion treats for birthdays, holidays, and training rewards.",
      "Recipes for dogs with dietary restrictions including grain-free, low-fat, and allergy-friendly options.",
      "Tips for proper storage, portion sizes, and introducing new treats safely.",
      "Beautiful photography of finished treats that will make both dogs and owners drool.",
      "Cost-effective alternative to expensive commercial treats with known, quality ingredients.",
      "Perfect for dog owners who love to spoil their pets with homemade goodness.",
    ],
    Features: [
      "50+ homemade treat recipes",
      "Veterinary nutritionist approved",
      "Simple kitchen ingredients",
      "Special occasion treats",
      "Dietary restriction options",
      "Storage and safety tips",
      "Beautiful treat photography",
      "Cost-effective alternatives",
      "Quality ingredient focus",
      "Dog owner friendly",
      "Training reward ideas",
      "160 pages of delicious recipes",
    ],
  },
  {
    id: 20,
    name: "Dog Games",
    category: "Pet Activity Books",
    price: "27.95",
    country: "Australia",
    reviews: "198",
    rating: "4.7",
    images: ["/img/1020.jpg"],
    publisher: "Ellery Publications",
    isbn: "978-1-876720-82-7",
    pages: 176,
    description: [
      "Creative collection of indoor and outdoor games and activities to keep dogs mentally stimulated and physically active.",
      "Over 40 fun games ranging from simple puzzle toys to elaborate obstacle courses.",
      "Activities designed for different energy levels, ages, and physical abilities of dogs.",
      "DIY instructions for creating homemade toys and enrichment activities using household items.",
      "Mental stimulation games to prevent boredom and reduce destructive behaviors.",
      "Socialization activities for puppies and shy dogs to build confidence and social skills.",
      "Seasonal games and activities to keep dogs engaged throughout the year.",
      "Expert tips from animal behaviorists on the importance of play in canine development.",
      "Perfect for dog owners looking to strengthen their bond while keeping their pets happy and healthy.",
    ],
    Features: [
      "40+ engaging dog games",
      "Indoor and outdoor activities",
      "Age and ability appropriate",
      "DIY toy instructions",
      "Mental stimulation focus",
      "Behavioral problem prevention",
      "Puppy socialization games",
      "Seasonal activity ideas",
      "Animal behaviorist expertise",
      "Bonding activity emphasis",
      "Health and happiness focus",
      "176 pages of fun activities",
    ],
  },
];

export default productData;
